
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ats",
      function () {
        return require("private-next-pages/ats/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ats"])
      });
    }
  